const { isString } = require('../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @returns {*}
 */
function decimals ({ value }) {
  if (!value) return

  if (isString(value)) {
    if (value.toString().charAt(0) === '0') {
      return value.replace(/[^0-9.]+/g, '')
    } else {
      const val = parseFloat(value.replace(/[^0-9.]+/g, ''))
      return isNaN(val) ? '' : val
    }
  }

  return parseFloat(value)
}

module.exports = { decimals }
